const STRINGS = {
  LOGIN_SCREEN: {
    BANNER_TEXT: "Precision Logistics for India's Airforce of Tomorrow",
    INVALID_PHONE_NO: "Please enter valid mobile number.",
    INVALID_EMAIL: "Please enter valid email id.",
    NUM_REG_FOR_ANOTHER_ROLE: "Number already linked to a different role.",
    UNIDENTIFIED_USER:
      "Couldn’t find your account. Please check with your admin.",
    EXCEEDED_OTP_ATTEMPTS: "Oops! Maximum attempts reached.",
    OTP_REQ_FAILED: "Oops! OTP request failed.",
    INVALID_OTP: "Invalid OTP!",
    EXCEEDED_ATTEMPTS: "Oops! Maximum attempts reached.",
  },
};

export default STRINGS;
